class LocalStorage {
	constructor() {
		this.#validateStorage();

		this.get = this.get.bind(this);
		this.set = this.set.bind(this);
		this.has = this.has.bind(this);
		this.remove = this.remove.bind(this);
	}

	#validateStorage() {
		if (typeof Storage === 'undefined') {
			throw new Error('Sorry, your browser does not support Web Storage...');
		}
	}

	#validateKey(key) {
		if (typeof key !== 'string') {
			throw new Error('Key must be a string');
		}
	}

	/**
	 * @param {string} key
	 * @param {*} value
	 */
	set(key, value) {
		this.#validateKey(key);

		if (typeof value === 'undefined' || value === null) {
			throw new Error('value must be provided');
		}

		try {
			if (typeof value === 'object') {
				value = JSON.stringify(value);
			}

			localStorage.setItem(key, value);
		} catch (e) {
			console.error(e);
		}
	}

	/**
	 * @param {string} key
	 */
	get(key) {
		this.#validateKey(key);

		let params = localStorage.getItem(key);

		if (params === null) {
			throw new Error(`No param for "${key}"`);
		}
		if (params === 'undefined' || typeof params === 'undefined') {
			params = undefined;
		} else if (!Number.isNaN(Number(params))) {
			params = Number(params);
		} else {
			try {
				params = JSON.parse(params);
			} catch (e) {}
		}

		return params;
	}

	has(key) {
		this.#validateKey(key);
		let params = localStorage.getItem(key);
		if (
			params === null ||
			params === 'undefined' ||
			typeof params === 'undefined'
		) {
			return false;
		}

		return true;
	}

	remove(key) {
		this.#validateKey(key);

		try {
			localStorage.removeItem(key);
		} catch (e) {
			throw new Error(`No param for "${key}"`);
		}
	}
}

const storage = new LocalStorage();

export default storage;
